import { Box, Grid, Collapse, Typography } from "@mui/material";
import React from "react";
import ExpandMoreButton from "../../../../components/inputs/expandMoreButton/expandMoreButton";
import CoachListProps from "../interface/coachListProps";
import CoachProps from "../interface/coachProps";
import RenderCoachDetails from "./renderCoachDetails";
import RenderCoachName from "./editCoach/src/renderCoachName";
import { CoachListContext } from "../context/coachListContext";
import NoCoachesFoundMessage from "./noCoachesFoundMessage";
import OptionMenu from "./optionMenu";

const RenderList = (): React.JSX.Element => {
  const {
    coachList,
    setCoachList,
    search,
  }: {
    coachList: CoachListProps;
    setCoachList: (coachList: CoachListProps) => void;
    search: string;
  } = React.useContext(CoachListContext);

  const searchFilter: CoachProps[] = coachList.data.filter(
    (coach: CoachProps) =>
      coach.vorname.toLowerCase().includes(search.toLowerCase()) ||
      coach.nachname.toLowerCase().includes(search.toLowerCase())
  );

  if (searchFilter.length === 0) return <NoCoachesFoundMessage />;

  return (
    <React.Fragment>
      {coachList.fetched &&
        coachList.data.length > 0 &&
        searchFilter.map((coach: CoachProps) => (
          <Box
            key={coach.id}
            sx={{
              backgroundColor: "#eeeeee",
              mb: 2,
              p: 2,
              borderRadius: 2,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6} sm={6} md={8}>
                <RenderCoachName coach={coach} />
              </Grid>

              <Grid
                item
                xs={6}
                sm={6}
                md={2}
                sx={{
                  textAlign: "right",
                }}
              >
                <Typography
                  variant="caption"
                  color="span"
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  Status
                </Typography>
                <br />
                <Typography
                  variant="body1"
                  color={coach.active === 1 ? "success.main" : "error.main"}
                >
                  {coach.active === 1 ? "Aktiv" : "Inaktiv"}
                </Typography>
              </Grid>

              <Grid
                item
                xs={6}
                sm={6}
                md={2}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <OptionMenu coach={coach} />

                <ExpandMoreButton
                  onClick={() => {
                    setCoachList({
                      ...coachList,
                      data: coachList.data.map((coachItem) => {
                        if (coachItem.id === coach.id) {
                          coachItem.expand = !coachItem.expand;
                        }
                        return coachItem;
                      }),
                    });
                  }}
                  expand={coach.expand}
                />
              </Grid>
            </Grid>

            <Collapse in={coach.expand}>
              <RenderCoachDetails coach={coach} />
            </Collapse>
          </Box>
        ))}
    </React.Fragment>
  );
};

export default RenderList;
